<template>
    <div class="protocolDialogWrap">
        <el-dialog
                :title="$t('message.insuranceExclusions')"
                :close-on-click-modal="false"
                append-to-body
                :visible.sync="isShowDialog"
                :before-close="cancelClick"
                width="430px"
                custom-class="protocolVerifyDialog">
            <div class="tit">{{$t('message.waiver')}}</div>
            <p class="protocol">{{$t('message.disclaimerClause0')}}</p>
            <p class="protocol">{{$t('message.disclaimerClause1')}}</p>
            <p class="protocol">{{$t('message.disclaimerClause2')}}</p>
            <p class="protocol">{{$t('message.disclaimerClause3')}}</p>
            <p class="protocol">{{$t('message.disclaimerClause4')}}</p>
            <p class="protocol">{{$t('message.disclaimerClause5')}}</p>
            <p class="protocol">{{$t('message.disclaimerClause6')}}</p>
            <p class="protocol">{{$t('message.disclaimerClause7')}}</p>
            <p class="protocol">{{$t('message.disclaimerClause8')}}</p>
            <p class="protocol">{{$t('message.disclaimerClause9')}}</p>
            <p class="tips">{{$t('message.insuranceTips2')}}</p>
            <p class="tips">{{$t('message.insuranceTips3')}}</p>
            <div v-if="isShowConfirm" style="text-align: right;">
                <el-button size="mini"
                           type="primary"
                           @click="confirmClick();$bigData('insuranceAgree', '协议确认', '1');">
                    {{$t('message.affirm')}}
                </el-button>
                <el-button size="mini" @click="cancelClick">{{$t('message.cancel')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'GoodsExtensionInsuranceProtocolDialog',// 货延险协议弹窗
        props: {
            // 显示组件
            show: {
                type: Number,
                default: -1
            },
            // 显示确认取消
            isShowConfirm: {
                type: Boolean,
                default: true
            },
            // 回调fn
            callback: {
                type: Function,
                default: () => {
                }
            },
            // 取消回调fn
            cancelCallback: {
                type: Function,
                default: () => {
                }
            },
        },
        data() {
            return {
                // 是否显示弹窗
                isShowDialog: false
            };
        },
        watch: {
            show() {
                // 发生变化显示
                this.isShowDialog = true;
            }
        },
        methods: {
            // 点击确定协议
            confirmClick() {
                this.$Confirm({
                    msg: this.$t('message.buyInsuranceConfirm'),
                    callback: () => {
                        this.isShowDialog = false;
                        this.callback();// 执行传入的回调
                    }
                });
            },
            // 点击取消回调
            cancelClick() {
                this.isShowDialog = false;
                this.cancelCallback();// 执行传入的回调
                // 大数据
                this.$bigData('insuranceNotAgree', '协议取消', '1');
            }
        }
    };
</script>

<style lang="scss" scoped>
    /deep/ .protocolVerifyDialog {
        .el-dialog__body {
            padding: 0 20px 30px;
        }

        .tit {
            margin: 0 0 30px 0;
            font-size: 20px;
            font-weight: bold;
            text-align: center;
        }

        .protocol {
            margin: 20px 0;
        }

        .tips {
            margin-bottom: 10px;
            font-size: 12px;
            color: red;
        }
    }
</style>
